<div>
  <header class="container-header" style="background-color: #5b43d9">
    <div
      class="header"
      style="
        max-width: 1300px;
        width: 100%;
        display: flex;
        align-items: center;
        height: 70px;
        margin: 0 auto;
        justify-content: space-between;
      "
    >
      <a routerLink="/home">
        <img src="assets/icons/logo.svg" style="cursor: pointer; width: 5rem" />
      </a>

      <div
        class="pages-container"
        style="display: flex; align-items: center; gap: 15px"
      >
        <div>
          <a id="btn-dashboard" mat-list-item routerLink="/home">
            <div
              [class.active]="this.activePage == 'home'"
              class="menu-btn"
              style="display: flex; align-items: center"
            >
              <img src="assets/icons/dashboard-icon.svg" alt="" />
              <p style="margin: 0; padding-left: 5px" class="text">Dashboard</p>
            </div>
          </a>
        </div>
        <div>
          <a id="btn-real-time" mat-list-item routerLink="real-time">
            <div
              [class.active]="this.activePage == 'real-time'"
              class="menu-btn"
              style="display: flex; align-items: center"
            >
              <img src="assets/icons/realtime-icon.svg" alt="" />
              <p style="margin: 0; padding-left: 5px" class="text">Real-Time</p>
            </div>
          </a>
        </div>
        <div>
          <a id="btn-complaints" mat-list-item routerLink="ocurrences">
            <div
              [class.active]="this.activePage == 'ocurrences'"
              class="menu-btn"
              style="display: flex; align-items: center"
            >
              <img src="assets/icons/ocurrences-icon.svg" alt="" />
              <p style="margin: 0; padding-left: 5px" class="text">
                Ocorrências
              </p>
            </div>
          </a>
        </div>
        <div *ngIf="superUser || adminUser">
          <a id="btn-all-users" mat-list-item routerLink="manage-users">
            <div
              [class.active]="this.activePage == 'users'"
              class="menu-btn"
              style="display: flex; align-items: center"
            >
              <img src="assets/icons/usermanagement-icon.svg" alt="" />
              <p style="margin: 0; padding-left: 5px" class="text">
                Gerenciar Usuários
              </p>
            </div>
          </a>
        </div>
      </div>

      <div
        class="perfil-container"
        style="display: flex; align-items: center; gap: 30px"
      >
        <div class="position-relative">
          <div *ngIf="newNotification" class="notification-warning"></div>

          <img
            src="assets/icons/notifications.svg"
            style="cursor: pointer"
            (click)="openNotifications()"
          />
        </div>

        <mat-menu #menu="matMenu" id="btn-perfil">
          <button routerLink="user/detail" mat-menu-item>
            <mat-icon>person</mat-icon> Meu perfil
          </button>
          <button routerLink="/support" mat-menu-item>
            <mat-icon>help_outline</mat-icon> Suporte
          </button>
          <button (click)="logout()" mat-menu-item id="btn-logout">
            <mat-icon>power_settings_new</mat-icon> Sair
          </button>
        </mat-menu>

        <div
          style="
            background-color: #4f34cd;
            border-radius: 1000px;
            padding: 5px 15px;
          "
          class="toolbar-right"
        >
          <div>
            <div class="header-text"></div>
            <div class="img-container">
              <img
                class="user-img"
                src="./../../assets/icons/genericUser.svg"
              />
            </div>
          </div>
          <button
            mat-button
            [matMenuTriggerFor]="menu"
            class="btn btn-options"
            id="btn-perfil-logout"
          >
            <mat-icon style="font-size: 26px">keyboard_arrow_down</mat-icon>
          </button>

          <mat-menu #menu="matMenu" id="btn-perfil">
            <button routerLink="user/detail" mat-menu-item>
              <mat-icon>person</mat-icon> Meu perfil
            </button>
            <button routerLink="/support" mat-menu-item>
              <mat-icon>help_outline</mat-icon> Suporte
            </button>
            <button (click)="logout()" mat-menu-item id="btn-logout">
              <mat-icon>power_settings_new</mat-icon> Sair
            </button>
          </mat-menu>
        </div>
      </div>
    </div>
  </header>
  <!--
  <mat-toolbar style="position: fixed;z-index: 1000;">
    <div class="toolbar-left">
      <button
        id="btn-menu"
        mat-icon-button
        class="example-icon"
        aria-label="Example icon-button with menu icon"
        (click)="snav.toggle(); menuAction()"
      >
        <mat-icon>menu</mat-icon>
      </button>
      <span>
        <img
          (click)="backToHome()"
          class="logo-nina"
          src="./../../../assets/images/logo-nina.svg"
          alt="Logo da Nina"
        />
      </span>
    </div>
    <div class="toolbar-right">
      <div
        *ngIf="user.locale == 'e92a593e-308d-4c8a-bd14-aa7da19292aa'"
        style="display: flex; justify-content: center; align-items: center"
      >
        <div class="header-text">
          <h4 class="header-title">Prefeitura de Fortaleza</h4>
          <h4 class="header-title-mobile">PMF</h4>
          <p class="header-name">Olá, {{ user.username }}</p>
        </div>
        <div class="img-container">
          <img
            class="user-img"
            src="./../../assets/images/brazao_fortaleza.png"
            alt="Brazão da prefeitura"
          />
        </div>
      </div>
      <button mat-button [matMenuTriggerFor]="menu" class="btn btn-options" id="btn-perfil-logout">
        <mat-icon>keyboard_arrow_down</mat-icon>
      </button>
      <mat-menu #menu="matMenu" id="btn-perfil">
        <button routerLink="user/detail" mat-menu-item>
          <mat-icon>person</mat-icon> Meu perfil
        </button>
        <button (click)="logout()" mat-menu-item id="btn-logout">
          <mat-icon>power_settings_new</mat-icon> Sair
        </button>
      </mat-menu>
    </div>
  </mat-toolbar>
  -->
  <mat-sidenav-container [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
    <mat-sidenav-content>
      <router-outlet style="margin-bottom: 30px"></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
